import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { comnUtils, comnEnvs } from "@/comn/utils";
import { Grid } from "@/comn/components";
import { Page, Group, Layout, Button } from "@/comn/components";
import { useForm, useFetch, usePopup, useStore, useToast, useGrid, useModal } from "@/comn/hooks";
import {
    BASE,
    APIS,
    SCHEMA_FORM_CNTY_CD_SRCH,
    SCHEMA_GRID_CNTY_CD,
    SCHEMA_FORM_ROLE_CD_SRCH,
    SCHEMA_GRID_ROLE_CD,
} from "./services/ComnCdService";
import { Link } from "react-router-dom";

export const RoleCodeList = (props: any) => {
    debugger;

    const pgeUid = "roleCdLst";
    const { t } = useTranslation();
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid });
    const toast = useToast();
    const modal = useModal(); // Modal Window Hook !== Modal 창 Hook ==!
    const params = props.params;

    const form = {
        roleCdSrch: useForm({
            defaultSchema: SCHEMA_FORM_ROLE_CD_SRCH,
            // defaultValues: { ...pgeStore?.form } || {},
        }),
    };

    const grid = {
        roleCdLst: useGrid({
            defaultSchema: SCHEMA_GRID_ROLE_CD,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };

    const fetch = {
        getRoleCdLst: useFetch({
            api: (page = grid.roleCdLst.page) => {
                return APIS.getRoleCdLst(form.roleCdSrch.getValues(), page, grid.roleCdLst.size);
            },
            enabled: comnUtils.isEmpty(form.roleCdSrch.errors) && form.roleCdSrch.isSubmitted,
            key: [grid.roleCdLst.page, grid.roleCdLst.size],
            onSuccess: () => {
                setStore(pgeUid, {
                    form: form.roleCdSrch.getValues(),
                    page: grid.roleCdLst.page,
                    size: grid.roleCdLst.size,
                });
            },
        }),
    };

    const handler = {
        click_Btn_Srch: () => {
            form.roleCdSrch.handleSubmit(
                () => {
                    grid.roleCdLst.setPage(0);
                    fetch.getRoleCdLst.fetch(0);
                },
                () => {
                    toast.showToast({ type: "warning", content: "msg.00002" });
                },
            )();
        },

        /* * */
        click_Btn_Apply: () => {
            const list: any[] = grid.roleCdLst.getChecked() || [];
            if (comnUtils.isEmpty(list)) {
                modal.openModal({ content: "msg.com.00086" });
                return;
            }
            props?.callback?.({ data: list });
            modal.closeModal(props.id);
        },
    };

    const render = {
        grid_RoleCdLst: {
            cell: {
                roleId: (arg: any) => {
                    const { binding, rowValues, value } = arg;
                    return (
                        <Link
                            to={"#"}
                            onClick={(e) => {
                                e.preventDefault();
                                props?.callback?.({ code: value, label: rowValues.roleNm });
                                modal.closeModal(props.id);
                            }}
                        >
                            {arg.value}
                        </Link>
                    );
                },
            },
        },
    };

    useEffect(() => {
        handler.click_Btn_Srch();
        /* * */
        if (params?.multiple === true) {
            grid.roleCdLst.setOption("checkbox", true);
        }
    }, []);

    return (
        <Page title={t("T_ROLE_LST")} info={true}>
            <form>
                <Group>
                    <Group.Body>
                        <Group.Section>
                            <Group.Row>
                                <Group.Control {...form.roleCdSrch.schema.roleId}></Group.Control>
                                <Group.Control {...form.roleCdSrch.schema.roleNm}></Group.Control>
                            </Group.Row>
                        </Group.Section>
                        <Layout direction="row">
                            <Layout.Left>
                                <Button
                                    onClick={() => {
                                        form.roleCdSrch.reset();
                                    }}
                                >
                                    {t("B_RESET")}
                                </Button>
                            </Layout.Left>
                            <Layout.Right>
                                <Button
                                    onClick={() => {
                                        handler.click_Btn_Srch();
                                    }}
                                >
                                    {t("B_SRCH")}
                                </Button>
                            </Layout.Right>
                        </Layout>
                    </Group.Body>
                </Group>
            </form>

            <Group>
                <Group.Body>
                    <Group.Section>
                        {/* * */}
                        {params?.multiple === true && (
                            <Layout>
                                <Layout.Right>
                                    <Button
                                        role="apply"
                                        onClick={() => {
                                            handler.click_Btn_Apply();
                                        }}
                                    ></Button>
                                </Layout.Right>
                            </Layout>
                        )}
                        <Grid
                            {...grid.roleCdLst.grid}
                            data={fetch.getRoleCdLst.data?.roleCdList}
                            render={render.grid_RoleCdLst}
                        />
                    </Group.Section>
                </Group.Body>
            </Group>
        </Page>
    );
};
